'use strict';

/* Directives */

angular.module('myApp.directives', [])

	//Fit to window
	.directive("fitWin", function () {
		return {
			restrict : 'A',
			link : function (scope, elem, attrs) {
				var height, width;
				height = $(window).height();
				elem.css('height', height - (height * .15));

				$(window).on('resize', function () {
					height = $(window).height();
					elem.css('height', height - (height * .15));
					//Fix for scrolling problem
					ROADMAP.ol.getMap().updateSizeDestroy();
				})

				//Fix for scrolling problem
				ROADMAP.ol.getMap().updateSizeDestroy();
			}
		}
	})

	//Maps dropdown drawer
	.directive("mapCartToggle", function () {
		return {
			restrict : 'C',
			link : function (scope, elm, attrs) {

				$(elm).on('click', function (e) {
					e.preventDefault();
					var clickTarget = (e.target);
					$(".map-cart-inner").slideToggle('fast');
				});

			}
		}
	})
	.directive('checkAndAnchorScroll', function($location,$anchorScroll) {
	  return function(scope, element, attrs) {
	  	//no blue, just bold
	      if(attrs.id === $location.hash()){
	      	setTimeout(function () {
	      	  $anchorScroll();
	      	  window.scrollBy(0,-70)
	      	}, 100);
	      }
	  };
	});